<header>
  <h1>Event Admin</h1>
</header>
<div class="filtersSection">
  <section class="filters filter-select">
    <mat-button-toggle-group
      #typeFilter="matButtonToggleGroup"
      (change)="setType(typeFilter.value)"
      >
      <mat-button-toggle disabled value="*"> Type: </mat-button-toggle>
      <mat-button-toggle value="null" checked>
        <mat-icon>list</mat-icon>
        All
      </mat-button-toggle>
      <mat-button-toggle value="ticket">
        <mat-icon>payment</mat-icon>
        Tickets
      </mat-button-toggle>
      <mat-button-toggle value="ballot">
        <mat-icon>local_activity</mat-icon>
        Ballots
      </mat-button-toggle>
    </mat-button-toggle-group>
  </section>

  @if (isOrgAdmin) {
    <section class="filters filter-select">
      <mat-button-toggle disabled value="*"> Organisation: </mat-button-toggle>
      <mat-select
        (selectionChange)="setOrgFilter($event.value)"
      style="
        background-color: white;
        padding: 10px 20px;
        display: flex;
        align-items: center;
      "
        [(value)]="orgSelected"
        >
        <mat-option value="all">All</mat-option>
        @for (org of userOrgs; track org) {
          <mat-option [value]="org.company_id"
            >{{org.title}}</mat-option
            >
          }
        </mat-select>
      </section>
    }
  </div>
  <section>
    @if (loading) {
      <mat-card class="loading">
        <mat-card-content>
          <mat-icon>autorenew</mat-icon>
          Loading&hellip;
        </mat-card-content>
      </mat-card>
    }
    @if (!loading) {
      <section class="date-pagination">
        <mat-button-toggle-group
          #pageSizePicker="matButtonToggleGroup"
          (change)="setPageSize(pageSizePicker.value)"
          [value]="pageSize"
          >
          <mat-button-toggle value="day"> Day </mat-button-toggle>
          <mat-button-toggle value="week"> Week </mat-button-toggle>
          <mat-button-toggle value="month"> Month </mat-button-toggle>
        </mat-button-toggle-group>
        <section class="date-range">
          {{ DateRange.startDate | date : 'd MMM yyyy' }}{{ DateRange?.endDate ?
          (DateRange.endDate | date : ' - d MMM yyyy') : '' }}
        </section>
        <section class="date-navigation">
          <button (click)="decrementStartDate()" mat-raised-button>
            <mat-icon>keyboard_arrow_left</mat-icon>
          </button>
          <button (click)="startDateToday()" mat-raised-button>Today</button>
          <button (click)="incrementStartDate()" mat-raised-button>
            <mat-icon>keyboard_arrow_right</mat-icon>
          </button>
        </section>
      </section>
      @if (!Events?.length) {
        <mat-card class="no-results">
          <mat-card-content>
            <mat-icon>sentiment_dissatisfied</mat-icon>
            No events found.
          </mat-card-content>
        </mat-card>
      }
      @if (!!Events?.length) {
        <table mat-table [dataSource]="DataSource" class="event">
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          <!-- [ngClass]="{disabled: !row.ticketsAvailable || !row.flags.live}" -->
          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef>Type</th>
            <td mat-cell *matCellDef="let row">
              <mat-icon
                >{{ row.type == 'ballot' && 'local_activity' || 'payment'
                }}</mat-icon
                >
              </td>
            </ng-container>
            <ng-container matColumnDef="event_title">
              <th mat-header-cell *matHeaderCellDef>Event</th>
              <td mat-cell *matCellDef="let row">{{ row.event_title }}</td>
            </ng-container>
            <ng-container matColumnDef="location_title">
              <th mat-header-cell *matHeaderCellDef>Location</th>
              <td mat-cell *matCellDef="let row">{{ row.location_title }}</td>
            </ng-container>
            <ng-container matColumnDef="date">
              <th mat-header-cell *matHeaderCellDef>Date</th>
              <td mat-cell *matCellDef="let row">
                {{ row.start_date | date : 'dd/MM/yyyy' }}
              </td>
            </ng-container>
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef class="actions">Actions</th>
              <td mat-cell *matCellDef="let row" class="actions">
                <button
                  (click)="guestList(row)"
                  [disabled]="!row.showGuestList"
                  mat-icon-button
                  matTooltip="Guest list"
                  >
                  <mat-icon>list</mat-icon>
                </button>
                <button
                  (click)="runManualBallot(row)"
                  [disabled]="row.type != 'ballot'"
                  mat-icon-button
                  matTooltip="Run ballot manually"
                  >
                  <mat-icon>shuffle</mat-icon>
                </button>
              </td>
            </ng-container>
          </table>
          @if (PageEvent) {
            <mat-paginator
              (page)="DataSource.loadWithDateRange(DateRange,$event)"
              [length]="PageEvent.length"
              [pageIndex]="PageEvent.pageIndex"
              [pageSize]="PageEvent.pageSize"
            ></mat-paginator>
          }
        }
      }
    </section>
